__turbopack_context__.v({
  "image": "styles-module-scss-module__1skGpq__image",
  "link": "styles-module-scss-module__1skGpq__link",
  "links": "styles-module-scss-module__1skGpq__links",
});
